module.exports = __webpack_public_path__ + "static/media/ANY.af5bcfa9.png";